import { ENDPIONTS, Operation, PaginatedResult, httpService } from "@api";
import { PaperHeader } from "@components";
import { useFetch } from "@hooks";
import { Branch, SuspensionResponse, Termination } from "@models";
import { Action, ComplexHeader, ExportData, Filterable, Table, TableVerticalConfigs } from "@shared";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const SuspensionReport = () => {
  const [queryStrings] = useSearchParams();
  const navigate = useNavigate();

  const fetchData = useFetch<PaginatedResult<SuspensionResponse>>(
    {
      endPoint: ENDPIONTS.suspensions,
      queryStrings: queryStrings,
    },
    new PaginatedResult<SuspensionResponse>()
  );

  const fetchBranches = useFetch<PaginatedResult<Branch>>(
    {
      endPoint: ENDPIONTS.branches,
      ignorePagination: true,
    },
    new PaginatedResult<Branch>()
  );

  useEffect(() => {}, [fetchData?.isFetching]);

  const headers: ComplexHeader[] = [
    // { key: "employeeId", title: "employee Id" },
    { key: "employeeName", title: "employee" },
    { key: "branchName", title: "branch" },
    { key: "period", title: "period" },
    { key: "remarks", title: "remarks" },
    { key: "createdBy", title: "createdBy" },
    { key: "createdAt", title: "createdAt", format: "date" },
  ];

  const filters: Filterable<SuspensionResponse>[] = [
    // {
    //   key: "employeeName",
    //   title: "employee name",
    //   format: "text",
    //   operation: Operation.like,
    // },
    {
      key: "period",
      title: "Payroll Period",
      format: "month",
    },
    {
      key: "branchId",
      title: "branch",
      format: "select",
      data: [
        ...fetchBranches?.data?.items?.map((d) => ({
          id: d.id,
          name: d.location,
        })),
      ],
    },
  ];

  const onExport: ExportData = {
    data: () => excelData(),
    fileName: `Payroll Suspensions Report - ${new Date().toLocaleDateString()}`,
  };

  const excelData = async () => {
    queryStrings.set("size", (0).toString());

    const res = await httpService(ENDPIONTS.terminations, queryStrings).getAll();
    if (res.status === 200) {
      return (res.data as PaginatedResult<Termination>)?.items;
    }

    return [];
  };

  const onPrint = (element: HTMLElement) => {
    var subElement = element.querySelectorAll(":scope > div")[0];
    subElement.classList.remove("d-none");

    var subElement02 = element.querySelectorAll(":scope > div")[1];
    subElement02.classList.add("d-none");

    let table = element.getElementsByTagName("table")[0];
    table.classList.remove("table-striped");
  };

  const handlePageChange = (page: number, size: number) => {
    queryStrings.set("size", size.toString());
    queryStrings.set("page", (page - 1).toString());

    navigate({ search: `?${queryStrings.toString()}` });
  };

  return (
    <div className="content container-fluid">
      <div className="row align-items-center">
        <div className="d-flex justify-content-between mb-1">
          <div className="col-4">
            <h3 className="page-title">Payroll Suspensions Report</h3>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3" id="reportcontents">
        <PaperHeader title="Payroll Suspensions Report" />
        <div className="row mb-3">
          <div className="col-auto float-end ms-auto">
            <TableVerticalConfigs
              filters={filters}
              exportAsXSLS={onExport}
              onPrint={{
                ref: "reportcontents",
                prePrint: onPrint,
              }}
            />
          </div>
        </div>
        <Table
          class="table table-striped table-hover mb-0"
          data={fetchData?.data ?? []}
          headers={headers}
          isFetchingPage={fetchData.isFetching}
          showCounter
          onPageChange={handlePageChange}
          paginationClass="row mt-3"
        />
      </div>
    </div>
  );
};

export default SuspensionReport;
